import React, { useState } from 'react';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { firebaseConfig } from '../../firebase';
import { initializeApp } from 'firebase/app';

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);

const Recover = () => {
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSend = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch {
      setError('Failed to send reset email. Please check your address.');
    }
  };

  return (
<div className="w-full px-4 md:px-0 font-inter text-black">
  <div className="w-full text-left md:px-24">
    {/* Title Section */}
    <h2 className="text-[22px] md:text-[36px] text-[#03897B] lg:text-[47px] font-bold leading-[120%]">LOG IN</h2>
    <h2 className="text-[16px] sm:text-[20px] md:mt-4 md:text-[32px] font-semibold text-[#979797] leading-[120%] italic mt-1">
      Log in to farmnet
    </h2>

  {/* Optional image section placed separately below or above */}
  <div className="mt-8 items-center  flex md:mt-6 mt-5 justify-between ">

    {/* Subheading */}
    <h2 className="text-[16px] sm:text-[28px] font-bold leading-[120%] ">Farm IT, Digitalize IT!</h2>
   
    <img
      className="w-[180px] h-[50px] object-cover"
      alt="Logo"
      src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746207768/image_65_d0whes.png"
    />
  </div>
    <h2 className="text-[16px] sm:text-[20px] font-bold mt-3">Recover password</h2>
    <h2 className="text-[16px] sm:text-[20px] font-bold mt-3 mb-6">Get Password Reset Email</h2>

    {/* Form Section */}
    {!sent ? (
      <form onSubmit={handleSend} className="w-full max-w-screen">
        <input
          type="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          placeholder="Enter your email"
          className="w-full bg-[#03897B] border-[#03897B] shadow-black/30 placeholder:text-white text-white text-center text-[10px] md:text-[24px] font-bold rounded-[5px] h-[60px] outline-yellow-400"
        />
        <button
          type="submit"
          className="mt-4 bg-[#F38323] text-white font-bold shadow-black/30 shadow-inner py-3 w-full rounded-md text-base md:text-[18px]"
        >
          Send Reset Email
        </button>
        {error && <div className="text-red-600 mt-2">{error}</div>}
      </form>
    ) : (
      <div className="text-green-600 font-bold mt-4">
        Reset email sent!<br />Check your inbox.
      </div>
    )}
  </div>

  {/* Footer */}
  <div className="mt-8 text-left md:px-24">
    <p className="text-sm md:text-base">By</p>
    <p className="text-md font-bold md:text-xl">Farmers Networks</p>
  </div>
</div>

  );
};

export default Recover;